<template>
  <svg
    :viewBox="'0 0 ' + radius * 2 + ' ' + radius * 2"
    :height="radius * 2"
    :width="radius * 2"
    :class="[name]"
    aria-hidden="true"
    focusable="false"
  >
    <circle
      :stroke-dasharray="circumference() + ' ' + circumference()"
      :style="{ strokeDashoffset }"
      :stroke-width="stroke"
      :r="normalizedRadius"
      :cx="radius"
      :cy="radius"
      :class="`${name}__circle`"
      stroke="currentColor"
      fill="transparent"
      :transform="`rotate(-90, ${radius}, ${radius})`"
    />
  </svg>
</template>

<script>
export default {
  props: {
    radius: {
      type: Number,
      default: 29,
    },
    progress: {
      type: Number,
      default: 0,
    },
    stroke: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      name: 'a-svg-progress',
    }
  },
  computed: {
    strokeDashoffset() {
      return this.circumference() - (this.progress / 100) * this.circumference()
    },
    normalizedRadius() {
      return this.radius - this.stroke
    },
  },
  methods: {
    circumference() {
      return this.normalizedRadius * 2 * Math.PI
    },
  },
}
</script>

<style scoped lang="scss">
:disabled,
.disabled {
  pointer-events: none;
  stroke: $oslo-gray;
  opacity: 0.4;
}

.a-svg-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  stroke: $white;
  transition: stroke 0.2s ease-in-out, stroke-dashoffset 0.35s;

  &:hover,
  &:active {
    stroke: $supernova;
  }
}
</style>
